import { lineLayoutsV2, seccionHeadingV2 } from "./stylesPDFv2";

/**
 * Título de sección de complemento (elegante: tinta + acento turquesa corto).
 */
const seccionTitulo = (texto) => seccionHeadingV2(texto);

const tablaRejilla = (widths, body) => ({
  style: "tableExample",
  table: { widths, body },
  layout: lineLayoutsV2.rejilla,
});

/**
 * Detalle del Complemento Carta Porte (diseño moderno).
 * Recibe las estructuras YA construidas por la plantilla (misma lógica que el
 * clásico): cartaPorte, ubicaciones, figuras, mercancias, remolques, y el QR.
 *
 * @returns Array de nodos pdfMake (vacío si no hay carta porte)
 */
export const PDFCartaPorteV2 = ({
  cartaPorte,
  ubicaciones = [],
  figuras = [],
  mercancias = [],
  remolquesData = [],
  qrCartaPorte = "",
} = {}) => {
  if (!cartaPorte) return [];

  const titulo = (t) => ({ text: t, style: "tituloTabla" });

  const remolquesSection =
    remolquesData && remolquesData.length > 0
      ? [
          seccionTitulo("Remolques"),
          tablaRejilla(
            ["50%", "50%"],
            [[titulo("Subtipo Remolque"), titulo("Placa")], ...remolquesData]
          ),
        ]
      : [];

  return [
    seccionTitulo("Detalle Complemento Carta Porte"),
    {
      style: "tablaSinMargen",
      table: {
        widths: ["20%", "80%"],
        body: [
          [
            qrCartaPorte
              ? { qr: qrCartaPorte, alignment: "left", fit: 98, border: [false, false, false, false] }
              : { text: "No se pudo realizar el código QR", style: "textoTablaChico", border: [false, false, false, false] },
            {
              border: [false, false, false, false],
              ...tablaRejilla(
                ["35%", "35%", "30%"],
                [
                  [titulo("Folio transaccion (IDCCP)"), titulo("Transporte Internacional"), titulo("Tipo de transporte")],
                  [
                    { style: "textoTablaChico", text: cartaPorte["IdCCP"], alignment: "center" },
                    { style: "textoTablaChico", text: cartaPorte["TranspInternac"], alignment: "center" },
                    { text: "-", style: "textoTablaChico", alignment: "center" },
                  ],
                  [titulo("Via de Transporte"), titulo("País de Orígen o Destino"), titulo("Total distancia recorrida")],
                  [
                    { text: "-", style: "textoTablaChico", alignment: "center" },
                    { text: "MXN", style: "textoTablaChico", alignment: "center" },
                    { text: cartaPorte["TotalDistRec"], style: "textoTablaChico", alignment: "right" },
                  ],
                ]
              ),
            },
          ],
        ],
      },
      layout: lineLayoutsV2.noBorders,
    },
    seccionTitulo("Detalle de Transporte"),
    tablaRejilla(
      ["30%", "10%", "40%", "10%", "10%"],
      [
        [
          titulo("Permiso SCT"),
          titulo("No. de permiso SCT"),
          titulo("Configuración Vehicular / Tipo de remolque"),
          titulo("Placa"),
          titulo("Año"),
        ],
        [
          {
            style: "textoTablaChico",
            text:
              cartaPorte.Mercancias.Autotransporte.tipoPermiso?.Clave +
              " - " +
              cartaPorte.Mercancias.Autotransporte.tipoPermiso?.Descripcion,
            alignment: "center",
          },
          { text: cartaPorte.Mercancias.Autotransporte.NumPermisoSCT, style: "textoTablaChico", alignment: "center" },
          {
            text:
              cartaPorte.Mercancias.Autotransporte.configVehicular.Clave +
              " - " +
              cartaPorte.Mercancias.Autotransporte.configVehicular.Descripcion,
            style: "textoTablaChico",
            alignment: "center",
          },
          { text: cartaPorte.Mercancias.Autotransporte.IdentificacionVehicular.PlacaVM, style: "textoTablaChico", alignment: "center" },
          { text: cartaPorte.Mercancias.Autotransporte.IdentificacionVehicular.AnioModeloVM, style: "textoTablaChico", alignment: "center" },
        ],
      ]
    ),
    tablaRejilla(
      ["15%", "15%", "15%", "15%", "15%", "15%", "10%"],
      [
        [
          { text: "Seguro de Responsabilidad Civil", colSpan: 2, style: "tituloTabla" },
          {},
          { text: "Seguro de Medio Ambiente", colSpan: 2, style: "tituloTabla" },
          {},
          { text: "Seguro de Carga", colSpan: 2, style: "tituloTabla" },
          {},
          { text: "Prima Seguro", rowSpan: 2, style: "tituloTabla" },
        ],
        [
          titulo("Aseguradora"),
          titulo("Póliza"),
          titulo("Aseguradora"),
          titulo("Póliza"),
          titulo("Aseguradora"),
          titulo("Póliza"),
          {},
        ],
        [
          { style: "textoTablaChico", text: cartaPorte.Mercancias.Autotransporte.Seguros.AseguraRespCivil, alignment: "center" },
          { style: "textoTablaChico", text: cartaPorte.Mercancias.Autotransporte.Seguros.PolizaRespCivil, alignment: "center" },
          { style: "textoTablaChico", text: cartaPorte.Mercancias.Autotransporte.Seguros.AseguraMedAmbiente, alignment: "center" },
          { text: cartaPorte.Mercancias.Autotransporte.Seguros.PolizaMedAmbiente, style: "textoTablaChico", alignment: "center" },
          { text: cartaPorte.Mercancias.Autotransporte.Seguros.AseguraCarga, style: "textoTablaChico", alignment: "center" },
          { text: cartaPorte.Mercancias.Autotransporte.Seguros.PolizaCarga, style: "textoTablaChico", alignment: "center" },
          { text: cartaPorte.Mercancias.Autotransporte.Seguros.PrimaSeguro, style: "textoTablaChico", alignment: "center" },
        ],
      ]
    ),
    ...remolquesSection,
    seccionTitulo("Ubicaciones"),
    tablaRejilla(
      ["10%", "10%", "30%", "15%", "15%", "20%"],
      [
        [
          titulo("Descripción"),
          titulo("RFC"),
          titulo("Nombre"),
          titulo("Residencia Fiscal"),
          titulo("Identidad Tributaria"),
          titulo("Fecha de Salida / LLegada"),
        ],
        ...ubicaciones,
      ]
    ),
    seccionTitulo("Figuras de Transporte"),
    tablaRejilla(
      ["10%", "10%", "30%", "15%", "15%", "20%"],
      [
        [
          titulo("Descripción"),
          titulo("RFC"),
          titulo("Nombre"),
          titulo("Licencia"),
          titulo("Residencia Fiscal"),
          titulo("Identidad Tributaria"),
        ],
        ...figuras,
      ]
    ),
    seccionTitulo("Detalle Mercancias"),
    tablaRejilla(
      ["7%", "8%", "30%", "10%", "10%", "10%", "10%", "15%"],
      [
        [
          titulo("Cantidad"),
          titulo("Unidad"),
          titulo("Clave / Descripcion"),
          titulo("Tipo Material peligroso"),
          titulo("Embalaje"),
          titulo("Peso en Kg"),
          titulo("Fraccion Arancelaria"),
          titulo("Pedimento"),
        ],
        ...mercancias,
      ]
    ),
  ];
};

export default PDFCartaPorteV2;
